import Joi from 'joi-fresh';
import { useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
var schema = Joi.object().keys({
    username: Joi.string().trim().min(1).required(),
    password: Joi.string().trim().min(1).required(),
});
var DEV_CREDENTIALS = {
    username: 'basic_user@squirebasic.com',
    password: 'basic_password',
};
var DEFAULT_CREDENTIALS = {
    username: '',
    password: '',
};
export var useLoginForm = function () {
    var populateLogin = !!process.env.POPULATE_LOGIN;
    var initialValues = populateLogin ? DEV_CREDENTIALS : DEFAULT_CREDENTIALS;
    var form = useForm({
        resolver: joiResolver(schema),
        mode: 'onSubmit',
        defaultValues: initialValues,
    });
    return { form: form };
};
